/* angular:styles/component:css;159bb8f1a8a95fe802c2c4b4d655cb1856b894cc159a6b3012a505c02095d17f;/src/src/app/index/shared/sumState.ts */
.sum-state-icon > ion-icon {
  font-size: 20pt !important;
}
/*# sourceMappingURL=sumState.css.map */
